import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    /* Mobilde daha küçük boyut */
    gap: 0.3rem;
    
    /* Mobilde scale'i küçült */
    transform: scale(0.85);
  }
`;

const ToggleSwitch = styled.button<{ $isDark: boolean }>`
  position: relative;
  width: 60px;
  height: 30px;
  border: none;
  border-radius: 15px;
  background: ${props => props.$isDark 
    ? 'linear-gradient(135deg, #4a5568, #2d3748)' 
    : 'linear-gradient(135deg, #f7fafc, #edf2f7)'};
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: scale(1.05);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${props => props.theme.colors.primary}33;
  }
`;

const ToggleCircle = styled.div<{ $isDark: boolean }>`
  position: absolute;
  top: 2px;
  left: ${props => props.$isDark ? '32px' : '2px'};
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${props => props.$isDark 
    ? 'linear-gradient(135deg, #9ca3af, #6b7280)' /* Grimsi ton */
    : 'linear-gradient(135deg, #ffffff, #f7fafc)'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;

  &::before {
    content: '${props => props.$isDark ? '🌙' : '☀️'}';
    transition: all 0.3s ease;
  }
`;

const ToggleLabel = styled.span`
  font-size: 0.9rem;
  color: ${props => props.theme.colors.textSecondary};
  font-weight: 500;
  user-select: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <ToggleContainer>
      <ToggleLabel>{isDark ? 'Koyu Tema' : 'Açık Tema'}</ToggleLabel>
      <ToggleSwitch 
        onClick={toggleTheme}
        $isDark={isDark}
        aria-label={`${isDark ? 'Açık' : 'Koyu'} temaya geç`}
        title={`${isDark ? 'Açık' : 'Koyu'} temaya geç`}
      >
        <ToggleCircle $isDark={isDark} />
      </ToggleSwitch>
    </ToggleContainer>
  );
};